import { Button } from "@albelli/arc-3-react/lib/Button/Button";
import { requestSignOut } from "application/auth/authActions";
import { commonMessages } from "components/common/commonMessages";
import { PhotoOrganizer } from "components/common/PhotoOrganizer/PhotoOrganizer";
import { Xsell } from "components/common/Xsell/Xsell";
import { useIntl } from "components/_hooks/useIntl";
import React from "react";
import { useDispatch } from "react-redux";

export const OverviewMobile = () => {
  const dispatch = useDispatch();
  const onClick = () => {
    dispatch(requestSignOut());
  };
  const intl = useIntl();
  return (
    <div>
      <PhotoOrganizer className="arc3-margin--top-lg" />
      <div className="arc3-padding-lg">
        <Button onClick={onClick} className="arc3-no-margin arc3-full-width">
          {intl.formatMessage(commonMessages.signOut)}
        </Button>
      </div>
      <Xsell />
    </div>
  );
};
